import { render, staticRenderFns } from "./FlowOtherSetting.vue?vue&type=template&id=018c4b86&scoped=true&"
import script from "./FlowOtherSetting.vue?vue&type=script&lang=js&"
export * from "./FlowOtherSetting.vue?vue&type=script&lang=js&"
import style0 from "./FlowOtherSetting.vue?vue&type=style&index=0&id=018c4b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c4b86",
  null
  
)

export default component.exports